import React from 'react'
import { headerAssets } from '../common/config'

const Header = () => {
  return (                                                                                
    <nav className='flex gap-5 px-5 py-[6px] items-center justify-between sm:justify-start border-b border-gray-border shadow-sm'>
        <img src={headerAssets?.spyneLogo} className='w-28 sm:w-40 h-auto'/>
        <div className='flex items-center gap-2'>
            <img src={headerAssets?.headerLogo} className='h-8'/>
            <h2 className='font-semibold text-base md:text-xl leading-10 text-spyne-blue whitespace-nowrap'>3D Journey Demo</h2>
        </div>
    </nav>
  )
}

export default Header